import { CardMedia } from '@mui/material';
import { Course } from '../../../core/interfaces/course.interface';
import { courseCardMediaSx } from './courseCardImage';

interface CourseCardMediaProps {
  course: Pick<Course, 'avatar' | 'name' | 'avatarPositionX' | 'avatarPositionY'>;
}

const CourseCardMedia = ({ course }: CourseCardMediaProps) => (
  <CardMedia
    sx={courseCardMediaSx(course.avatarPositionX, course.avatarPositionY)}
    image={course.avatar}
    title={course.name}
  />
);

export default CourseCardMedia;
